import React, { useState, useEffect } from 'react';
import ErpTemplate from '../../../components/ErpTemplate';
import { FaBan, FaCheck } from 'react-icons/fa';
import api from '../../../services/api';
import { useHistory, useLocation } from 'react-router-dom';
import { extract } from '../../../util/util';
import { toast } from 'react-toastify';
import MostrarHTML from '../../../components/MostrarHtml';
import { getText, getParticipantLanguage } from '../../../util/translations';

export default function CadastroEventoParticipanteCartaInformativa({ match }) {
    const id = match.params.id;
    const token = localStorage.getItem('token');
    const perfil = localStorage.getItem("perfil");
    const [data, setData] = useState(null);
    const [concordaConvite, setConcordaConvite] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isError, setIsError] = useState(false);
    const history = useHistory();
    const { state } = useLocation();
    const idioma = data?.idioma || state?.idioma || null;

    const buscar = () => {
        setIsLoading(true);
        setIsError(false);
        api({
            method: "get",
            action: '/participante/' + id,
            token: token,
        }).then(response => {
            //extrai dados internos para o array principal
            var dadosRecebidos = extract({
                jsonLaravel: response.data.data,
                chaves: [
                    'enderecopais',
                    'aereomunicipioembarque',
                    'enderecomunicipio',
                    'banco',
                ]
            });

            //se estiver em alguma situação do grupo "confirmado" ou "declinaram", mostrar concluído
            var gruposSituacao = dadosRecebidos.grupoSituacao ?? [];
            if (gruposSituacao.includes("confirmados") || gruposSituacao.includes("declinaram")) {
                history.push({
                    pathname: "/cadastroEventoParticipanteConviteConcluido/" + dadosRecebidos.evento.id,
                    state: { idioma: dadosRecebidos.idioma }
                });
                return;
            }

            api({
                method: "get",
                action: '/eventoCarta/visualizarCartaHtml/' + id,
                token: token,
                params: {
                    tipoCarta: "modelocarta",
                }
            }).then(response => {
                setData({
                    ...dadosRecebidos,
                    ...{ htmlCarta: response.data.data.htmlCarta }
                });
                setIsLoading(false);
            }).catch(function (error) {
                const msg = idioma
                    ? `${getText('error', idioma)} ${getText('errorLoadingDefault', idioma)}`
                    : <>{getText('error', 'portugues')} {getText('errorLoadingDefault', 'portugues')}<br />({getText('error', 'ingles')} {getText('errorLoadingDefault', 'ingles')})</>;
                toast.error(msg);
                setIsLoading(false);
                setIsError(true);
            });
        }).catch(err => {
            setIsLoading(false);
            setIsError(true);
            const message = idioma
                ? `${getText('error', idioma)} ${getText('errorLoadingDefault', idioma)}`
                : <>{getText('error', 'portugues')} {getText('errorLoadingDefault', 'portugues')}<br />({getText('error', 'ingles')} {getText('errorLoadingDefault', 'ingles')})</>;
            toast.error(message);
        });
    };//buscar

    const salvar = (aceitouConvite) => {
        /*
        api({
            method: 'put',
            action: '/participante/aceitarConvite/' + id,
            token: token,
            data: { aceitouConvite: aceitouConvite ? 'sim' : 'nao' },
        })
            .then(function (response) {
                if (aceitouConvite) {
                    history.push("/cadastroEventoParticipanteAceitarTermo/" + id);
                } else {
                    history.push("/cadastroEventoParticipanteConviteRecusado/" + data?.evento?.id, { idioma: idioma });
                }
            })
            .catch(function (error) {
                //alert(error)
            });
            */
    }; //salvar

    useEffect(() => { //onload
        buscar();
    },
        // eslint-disable-next-line
        []);

    return (
        <ErpTemplate sidebar={['listarsvp', 'cliente'].includes(perfil) ? false : true} processando={isLoading} idioma={idioma ?? "both"}>
            <div className="main-content container-fluid">
                <div className="page-title">
                    <h3>{getText('cartaInformativa', idioma)}</h3>
                </div>
                <section id="multiple-column-form">
                    <div className="row match-height">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-content">
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-sm-12">
                                                <MostrarHTML
                                                    htmlContent={data?.htmlCarta ?? null}
                                                />
                                            </div>
                                        </div>
                                        {/*
                                        <div className="row">
                                            <div className="col-sm-12 d-flex justify-content-end">
                                                <div className="form-check">
                                                    <div className="checkbox">
                                                        <label>
                                                            <input type="checkbox"
                                                                className="form-check-input"
                                                                value={concordaConvite}
                                                                checked={concordaConvite}
                                                                onChange={(value) => {
                                                                    setConcordaConvite(!concordaConvite);
                                                                }} />
                                                            {getText('agreeWithTerms', idioma)}</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm-12 d-flex justify-content-end">
                                                <button
                                                    type="button"
                                                    className="btn btn-danger me-1 mb-1"
                                                    onClick={() => {
                                                        salvar(false);
                                                    }}
                                                >
                                                    <FaBan size={20} /> {getText('declineInvite', idioma)}
                                                </button>
                                                <button
                                                    type="submit"
                                                    className="btn btn-success me-1 mb-1"
                                                    disabled={!concordaConvite}
                                                    onClick={() => {
                                                        salvar(true);
                                                    }}
                                                >
                                                    <FaCheck size={20} /> {getText('acceptInvite', idioma)}
                                                </button>
                                            </div>
                                        </div>
                                        */
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section >
            </div >
        </ErpTemplate >
    );
}
